import React, { Component } from 'react';
import Type from './Type';
import { Animated } from 'react-animated-css';
import './Intro.css';

import { Image, Header, Button, Icon, Reveal, Grid } from 'semantic-ui-react';
import myPhoto from '../images/test2.png';
import tools from '../images/tools.png';
import ContactModal from './ContactModal';

export default class Intro extends Component {
    render() {
        return (
            <Grid centered verticalAlign="middle">
                <Grid.Row>
                    <Grid.Column computer="10" tablet="15" mobile="15" verticalAlign="middle">
                        <br />

                        <Animated animationIn="fadeInDown" animationOut="fadeIn">
                            <Grid centered>
                                <Grid.Row>
                                    <Grid.Column computer="4" tablet="5" mobile="6">
                                        <Reveal animated="rotate">
                                            <Reveal.Content visible>
                                                <Image
                                                    src={myPhoto}
                                                    size="medium"
                                                    centered
                                                    circular
                                                    bordered
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        borderColor: 'grey',
                                                        borderWidth: 'medium',
                                                    }}
                                                />
                                            </Reveal.Content>

                                            <Reveal.Content hidden>
                                                <Image
                                                    src={tools}
                                                    size="medium"
                                                    centered
                                                    circular
                                                    bordered
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        borderColor: 'none',
                                                        borderWidth: 'medium',
                                                    }}
                                                />
                                            </Reveal.Content>
                                        </Reveal>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Animated>

                        <Header as="h3" inverted className="introTitle">
                            <p>
                                <Type
                                    strings=" Hi my name is <strong>Rafal Radomski</strong> <br><br> I'm a <strong>Senior JavaScript / Full Stack Engineer</strong> with 15+ years of experience."
                                    loop={false}
                                    loopDelay={5000}
                                    speed={30}
                                />
                            </p>
                        </Header>

                        <Animated animationIn="zoomInDown" animationInDelay={5000}>
                            <Header
                                as="h4"
                                inverted
                                className="introText"
                            >
                                <br />

                                <p>
                                    Specialised in JavaScript and TypeScript with extensive experience in{' '}
                                    <span className="skills">React</span>,{' '}
                                    <span className="skills">Next.js</span>,{' '}
                                    <span className="skills">Vue.js</span>,{' '}
                                    <span className="skills">Angular</span>,{' '}
                                    <span className="skills">Node.js</span>,{' '}
                                    <span className="skills">GraphQL</span>,{' '}
                                    <span className="skills">Micro Frontends</span> and{' '}
                                    <span className="skills">Module Federation</span>.
                                </p>

                                <p>
                                    Passionate about building clean, scalable, and maintainable applications with a
                                    strong focus on{' '}
                                    <span className="skills">accessibility (WCAG/ARIA)</span>, design systems,
                                    and automated testing.
                                </p>

                                <p>
                                    Experienced in modern front-end architecture, reusable component libraries and
                                    enterprise-scale web platforms, contributing across the full software delivery
                                    lifecycle from architecture and development to production deployments and{' '}
                                    <span className="skills">CI/CD</span>.
                                </p>

                                <p>
                                    Leveraging AI-assisted development tools like{' '}
                                    <span className="skills">Claude Code</span> and{' '}
                                    <span className="skills">GitHub Copilot</span> to improve developer productivity,
                                    code quality and software delivery.
                                </p>

                                <br />
                            </Header>
                        </Animated>

                        <Animated animationIn="zoomInDown" animationInDelay={5500}>
                            <div>
                                <a
                                    href="https://www.linkedin.com/in/rafal-radomski/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button primary animated="vertical" className="buttonFix">
                                        <Button.Content visible>
                                            <Icon name="linkedin" />
                                            Linkedin
                                        </Button.Content>

                                        <Button.Content hidden>
                                            <Icon name="right arrow" />
                                        </Button.Content>
                                    </Button>
                                </a>

                                <ContactModal />
                            </div>
                        </Animated>

                        <br />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Intro.js